'use client';

import classNames from 'classnames';
import { IconSoundOn } from '@picsart/design-system/foundation/icons/IconSoundOn';
import { IconSoundOff } from '@picsart/design-system/foundation/icons/IconSoundOff';

import type { VideoPlayerProps } from '@/components/LazyVideo/types';
import { TEST_IDS } from '@/components/LazyVideo/constants/testIds';
import useStyles from './styles';

const VideoPlayer = ({ videoRef, src, videoLabel, className, muted, width, height, onAudioToggle, onError, onLoadedData }: VideoPlayerProps) => {
  const classes = useStyles();
  const AudioToggleIcon = onAudioToggle && (muted ? IconSoundOff : IconSoundOn);

  return (
    <div className={classes.root}>
      <video
        ref={videoRef}
        style={{ aspectRatio: `${width}/${height}` }}
        className={classNames(classes.video, className)}
        loop
        src={src}
        muted={muted}
        playsInline
        preload="none"
        width={width}
        height={height}
        aria-label={videoLabel}
        onError={onError}
        onLoadedData={onLoadedData}
      />
      {AudioToggleIcon && (
        <button type="button" onClick={onAudioToggle} aria-label={muted ? 'Unmute video' : 'Mute video'} className={classes.audioButton} data-testid={TEST_IDS.AUDIO_TOGGLE}>
          <AudioToggleIcon className={classes.audioIcon} />
        </button>
      )}
    </div>
  );
};

export default VideoPlayer;
